export default __webpack_public_path__ + "static/media/TriangleMessageBox.f0f6d8c8.svg";